// @flow
import React, { Component, type Node } from 'react';
import { includes, isString } from 'lodash';
import styled from 'styled-components';

import { mergeClassNames } from 'utils/functions';

type CardProps = {
    /** card header, first header */
    header?: Node,
    /** card title: can be passed html, if only a string is provided it will default to H5 */
    title?: string,
    /** card subtitle: can be passed html, if only a string is provided it will default to H6 */
    subtitle?: string,
    /** will be appended to the classes */
    className: string,
    /** what will be rendered inside the card */
    children: Node,
    /** sets card bg color using BS 'light', 'primary', 'success', etc., use 'transparent' to reset */
    flavor: string,
    /* set border color using BS colors or theme colors */
    border: string,
    /* optional props passed to card-body */
    bodyProps: Object,
    /* optional node to render in card footer */
    footer?: Node,
};

const StyledCard = styled.div`
    border-radius: ${props => props.theme.borderRadius};
    border: none;
    h3 {
        font-size: 1.5rem;
        margin-bottom: ${props => props.theme.defaultSpacing};
    }

    .card-body {
        padding: ${props => props.theme.defaultSpacing};
        .container {
            box-shadow: 2px 2px 0px 0px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(0,0,0,0.14), 0px 2px 0px -1px rgba(0,0,0,0.12);
            margin-bottom: calc(1 * ${props => props.theme.defaultSpacing});
            overflow: hidden;
            padding-bottom: calc(1.5 * ${props => props.theme.defaultSpacing});
            padding-top: calc(1.5 * ${props => props.theme.defaultSpacing});
            > .row {
                /* padding: calc(2 * ${props => props.theme.defaultSpacing});
                margin-left: 0;
                margin-right: 0; */
            }
            :last-child { margin-bottom: 0; }
        }
    }
`;

export const CardTitle = ({ children }) => <h5 className='card-title'>{children}</h5>;

export class Card extends Component<CardProps> {
    static defaultProps = {
        className: '',
        flavor: 'white',
        border: '',
        bodyProps: {},
    };

    render() {
        let {
            title,
            subtitle,
            header,
            className,
            flavor,
            border,
            children,
            footer,
            bodyProps,
            ...domProps
        } = this.props;

        const needsLightText = ['dark'];
        const textColorClass = includes(needsLightText, flavor) ? 'text-light' : '';

        className = mergeClassNames(
            'card',
            this.props.className,
            `bg-${flavor}`,
            textColorClass,
            border && `border border-${border}`
        );

        const bodyClassName = mergeClassNames('card-body', bodyProps.className);

        return (
            <StyledCard className={className} {...domProps}>
                {header && <div className='card-header bg-transparent'>{header}</div>}
                <div {...bodyProps} className={bodyClassName}>
                    {isString(title) ? <CardTitle>{title}</CardTitle> : title}
                    {isString(subtitle) ? (
                        <h6 className='card-subtitle'>{subtitle}</h6>
                    ) : (
                        subtitle
                    )}
                    {children}
                </div>
                {footer && <div className={`card-footer bg-${flavor}`}>{footer}</div>}
            </StyledCard>
        );
    }
}

export default Card;
